import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Oracion from "./Oracion";

export default function OracionesMensajes() {
  const [fontSizes, setFontSizes] = useState(16);
  const [show, setShow] = useState(false);
  const [oracionElegida, setOracionElegida] = useState("");

  const aumentar = () => {
    if (fontSizes < 22) {
      const newSize = fontSizes + 2;
      setFontSizes(newSize);
    }
  };
  const restar = () => {
    if (fontSizes > 12) {
      const newSize = fontSizes - 2;
      setFontSizes(newSize);
    }
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="container devocionario">
        <div className={"font-" + fontSizes}>
          <div>
            <h6>
              Oración dada por la Ssma Virgen en Salta el 13 de Octubre de 1.995{" "}
            </h6>
            <i className="text-decoration-underline" onClick={() => {
                handleShow();
                setOracionElegida("mensaje13-10-95");
              }}>(ver Mensaje Completo)</i>
            <p>
              Santísima Trinidad que tu Santísima voluntad se cumpla, Tened
              Piedad de nosotros, Tened Piedad, Tened Misericordia, Tened
              Misericordia. <br />
              ¡Oh! Dios Misericordia, Misericordia. Por la Sangre del Cordero
              ten Piedad, Por la Pasión del Cordero ten Misericordia, Por las
              Llagas del Cordero ten Piedad. <br />
              Por Tu Hijo el Cordero de Dios escúchanos Padre apiádate de
              nosotros por el Nombre Bendito de tu Hijo Jesús. <br />
              Amén.
            </p>
          </div>
          <div>
            <h6>
              Oración Para Pedir Sabiduría, dada por la Ssma Virgen en Salta el
              22 de Noviembre de 1.995
            </h6>
            <i>(en un Mensaje Privado)</i>
            <p>
              ¡Dios mío y Señor mío Misericordioso! <br />
              Dame Santa Sabiduría que procede de tu infinita bondad, Abre los
              ojos de mi fe a la luz eterna, Para que con ellos te pueda ver,
              por que tu Sabiduría Señor, es más radiante que el sol. Guía mis
              pensamientos Señor con tú Sabiduría, para que sea la fuente de mi
              saber y obrar. Amén.
            </p>
          </div>
          <div>
            <h6>Oración dada en Salta el 27 de Noviembre de 1.995</h6>
            <i className="text-decoration-underline" onClick={() => {
                handleShow();
                setOracionElegida("mensaje27-11-95");
              }}>(ver Mensaje)</i>
            <p>
              ¡Oh! amor infinito que nunca cesas de llamar <br />
              ¡Oh! Pasión infinita que nunca dejas de padecer Tú llamas <br />
              Tú padeces <br />
              y amas las almas <br />
              porque almas de tu Alma son <br />
              Amén.
            </p>
          </div>
          <div>
            <h6>Oración dada en Salta el 21 de Marzo de 1.996 </h6>
            <i className="text-decoration-underline" onClick={() => {
                handleShow();
                setOracionElegida("mensaje21-03-96");
              }}>(ver Mensaje Completo)</i>
            <p>
              Alma Salvadora de Jesucristo, consume mi alma hasta la última gota
              de deseo de mi misma y satisfácela con el ferviente deseo de Tú
              Amor por las almas. <br />
              Que las gotas de Tú Sangre Redentora caigan en mí corazón, lo
              transformen y arrebaten hacia tu Divino Corazón. Amén.
            </p>
          </div>
          <div>
            <h6>
              Oración dada por la Ssma Virgen en Salta el 19 de Junio de 1.998
            </h6>
            <i className="text-decoration-underline" onClick={() => {
                handleShow();
                setOracionElegida("mensaje19-06-98");
              }}>(ver Mensaje Completo)</i>
            <p>
              - Sagrado y Divino Corazón de Jesús, humildemente creo que estás
              aquí presente. <br />
              - Creo con mi pobre corazón. <br />
              - Te adoro Hostia Divina y confío en Tu infinita Misericordia, que
              sostiene a toda humanidad. <br />
              - Sé que no soy digno de Ti, ayúdame a vencer las dificultades de
              ésta vida. <br />
              - Cambia mi corazón. <br />
              - Concédeme Gracia a través del Inmaculado Corazón de Tu Santa
              Madre. <br />
              - Bendito, adorado y alabado seas Corazón de Jesús. <br />
              Amén
            </p>
          </div>
          <div>
            <h6>Oración dada en Salta el 13 de Octubre de 1.998</h6>
            <i className="text-decoration-underline"  onClick={() => {
                handleShow();
                setOracionElegida("mensaje13-10-98");
              }}>(ver Mensaje Completo)</i>
            <p>
              ¡Me gozo en Ti Señor! <br />
              Que mi lengua te alabe y te bendiga. <br />
              Que mis ojos te busquen y mis manos te sirvan. Que en Ti repose mi
              alma. <br />
              Que el gozo y la alegría de mi corazón sean perfectos en Tu Santa
              Presencia. <br />
              Amén.
            </p>
          </div>
          <div>
            <h6>Oración dada en Salta el 13 de Octubre de 2.001 </h6>
            <i className="text-decoration-underline" onClick={() => {
                handleShow();
                setOracionElegida("mensaje13-10-01");
              }}>(ver Mensaje Completo)</i>
            <p>
              "Señor mío, y Dios mío ven a mi corazón renueva en mí la fe.{" "}
              <br />
              Abre mi corazón para recibir y para dar. <br />
              Lléname de tu amor".
            </p>
          </div>
          <div>
            <h6>
              Oración dada por la Ssma Virgen en Salta el 15 de Octubre de 2.001
            </h6>
            <i className="text-decoration-underline" onClick={() => {
                handleShow();
                setOracionElegida("mensaje15-10-01");
              }}>(ver Mensaje Completo)</i>
            <p>
              <strong>Orar con el corazón: </strong> Es querer amar a Dios sobre
              todas las cosas. <br />
              <strong>Orar con el corazón:</strong> Es encontrarse con Dios y
              solo con El. <br />
              <strong>Orar con el corazón:</strong> Es tener conciencia de hacer
              esto.
            </p>
          </div>
        </div>
      </div>
      <div className="btn-fonts d-flex">
        <button onClick={aumentar}>
          <strong>A</strong>
        </button>
        <button onClick={restar} style={{ fontSize: "1.1rem" }}>
          <strong>A</strong>
        </button>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Oracion oracionElegida={oracionElegida} />
        <Modal.Footer>
          <Button className="btn-fundacion" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
